import { createSignal, type Accessor, type Setter } from 'solid-js'
import { screenToSVG } from './utils'
import type { DragState, Position } from '../types'

interface DragMutableState {
	drag: DragState | null
	rsz:  DragState | null
}

// While a flex-container child is being drag-reordered, this holds the dragged child's id
// and the live (container-local) top to render it at, so the owning container can let the
// child follow the cursor while its siblings reflow into the vacated slot.
export interface ReorderDrag { id: string; top: number }

export interface DragContext {
	svgRef:          Accessor<SVGSVGElement | null>
	setSvgRef:       Setter<SVGSVGElement | null>
	handlesObject:    Accessor<SVGGElement | null>
	setHandlesObject: Setter<SVGGElement | null>
	dragState:       DragMutableState
	reorderDrag:     Accessor<ReorderDrag | null>
	setReorderDrag:  Setter<ReorderDrag | null>
	beginDrag:   (client: Position, onUpdate: (dx: number, dy: number) => void, onEnd: () => void) => void
	beginResize: (client: Position, onUpdate: (dx: number, dy: number) => void, onEnd: () => void) => void
}

export function createDragState(): DragContext {
	const [svgRef,       setSvgRef]       = createSignal<SVGSVGElement | null>(null)
	const [handlesObject, setHandlesObject] = createSignal<SVGGElement | null>(null)
	const [reorderDrag,  setReorderDrag]  = createSignal<ReorderDrag | null>(null)

	const dragState: DragMutableState = { drag: null, rsz: null }

	function beginDrag(client: Position, onUpdate: (dx: number, dy: number) => void, onEnd: () => void) {
		dragState.drag = { start: screenToSVG(svgRef(), client), onUpdate, onEnd }
	}
	function beginResize(client: Position, onUpdate: (dx: number, dy: number) => void, onEnd: () => void) {
		dragState.rsz = { start: screenToSVG(svgRef(), client), onUpdate, onEnd }
	}

	return { svgRef, setSvgRef, handlesObject, setHandlesObject, dragState, reorderDrag, setReorderDrag, beginDrag, beginResize }
}

